import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcVeryGood = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 57,
	viewBox: "0 0 56 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 28,
			cy: 28.666,
			r: 22,
			fill: "#D2D9E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2148 30.8789C19.2148 30.8789 21.2151 35.8795 28.216 35.8795C35.2169 35.8795 37.2171 30.8789 37.2171 30.8789",
			stroke: "white",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M37.0606 20.1517C37.3448 20.6253 37.1912 21.2395 36.7176 21.5237L33.1468 23.6662L36.7176 25.8087C37.1912 26.0928 37.3448 26.7071 37.0606 27.1807C36.7765 27.6542 36.1622 27.8078 35.6886 27.5237L30.6886 24.5237C30.3874 24.3429 30.2031 24.0174 30.2031 23.6662C30.2031 23.3149 30.3874 22.9894 30.6886 22.8087L35.6886 19.8087C36.1622 19.5245 36.7765 19.6781 37.0606 20.1517Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.8417 27.1823C17.5576 26.7087 17.7111 26.0945 18.1847 25.8103L21.7556 23.6678L18.1847 21.5253C17.7111 21.2412 17.5576 20.6269 17.8417 20.1533C18.1259 19.6797 18.7401 19.5262 19.2137 19.8103L24.2137 22.8103C24.5149 22.991 24.6992 23.3166 24.6992 23.6678C24.6992 24.0191 24.5149 24.3446 24.2137 24.5253L19.2137 27.5253C18.7401 27.8095 18.1259 27.6559 17.8417 27.1823Z",
			fill: "white"
		})
	]
});
export default SvgIcVeryGood;
